<template>
    <div class="tabs-wrapper">
        <ul class="tab-name" :class="{ 'flex-layout': flexStyle }">
            <li v-for="(item, index) in tabs" :key="index" @click="currentClick(index)" :class="{ on: activeIndex == index }">
                {{ item.tabName }}
                <slot :name="item.contentName"></slot>
            </li>
        </ul>
        <div class="tab-content">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "Tabs",
    props: ["currentIndex", "tabsConfig", "flexStyle"],
    data() {
        return {
            activeIndex: this.currentIndex ? this.currentIndex : 0
        };
    },
    computed: {
        tabs() {
            return this.tabsConfig;
        }
    },
    methods: {
        currentClick(index) {
            this.activeIndex = index;
            this.$emit("tabClick", {
                componentName: this.tabs[index].contentName
            });
        }
    }
};
</script>

<style scoped lang="less">
.tabs-wrapper {
    width: 100%;
    height: 100%;
    overflow: hidden;

    .tab-name {
        margin: 0;
        height: 48px;
        background: #fbfcfd;
        border-bottom: 1px solid #d9e4ef;
        box-sizing: border-box;
        padding: 0;
        li {
            padding: 14px 0 12px;
            margin: 0 40px;
            display: inline-flex;
            font-size: 14px;
            font-weight: bold;
            color: #41475e;
            border-bottom: 2px solid transparent;
            cursor: pointer;
            align-items: center;
            justify-content: center;
            &.on {
                border-color: #2ec2ff;
            }
        }
    }

    .flex-layout {
        display: flex;
        background: #fff;

        li {
            padding: 11px 0 10px;
            margin: 0 2px;
            flex: 1;
            text-align: center;
        }
    }

    .tab-content {
        height: calc(100% - 48px);
        overflow-y: auto;
    }
}
</style>
